// extracted by mini-css-extract-plugin
module.exports = {"fullscreenable":"Fullscreenable_fullscreenable__NFZO3","enable":"Fullscreenable_enable__B95cY","disable":"Fullscreenable_disable__fInCH"};